var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logo-picker',{attrs:{"upload-url":_vm.uploadUrl,"logo-url":_vm.logoUrl,"logo":_vm.logo},on:{"input":_vm.logoChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }